import React from "react";

import { CKEditor } from "../editor/ckeditor/CKEditor";
import { TextToSpeechPlayer } from "../editor/texttospeech/TextToSpeechPlayer";
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { Paper, AppBar, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	content: {
		marginTop: "69px",
		top: theme.mixins.toolbar.height,
		height: "calc(100vh - 40px - 69px)",
		overflow: "scroll",
		flexGrow: 1,
		[theme.breakpoints.down("sm")]: {
			borderRight: "1px solid #80808024",
		},
	},
	appBarBottom: {
		top: "auto",
		bottom: "0px",
	},
	builder: {
		height: `calc(100vh - 69px)`,
		width: "100%",
		margin: "0 auto",
	},
	editorWrapper: {
		height: "100%",
	},
	editor: {
		height: "100%",
	},
}));

interface Props {
	isMobileIconsDrawerOpen: boolean;
}

export function AndroidBuilderView(props: Props) {
	const classes = useStyles();
	const { onlineMode } = useOfflineAssets();

	return (
		<>
			<div className={classes.content}>
				<div className={classes.builder}>
					<Paper square className={classes.editorWrapper} elevation={2}>
						<CKEditor className={classes.editor} style={{ paddingRight: props.isMobileIconsDrawerOpen && onlineMode ? 60 : 28 }} />
						<TextToSpeechPlayer />
					</Paper>
				</div>
			</div>
			<AppBar position="fixed" color="primary" className={classes.appBarBottom}>
				<div className="mobile-toolbar">
					<div id="toolbar-container" />
				</div>
			</AppBar>
		</>
	);
}